import {gql} from '@apollo/client'

export const GET_ALL_COMMISSION_REPORTS_LOGS_API = gql`
  query allCommissionReportsLogs(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $status: String
    $matchType: String
    $commissionReport: String
    $client: String
    $memberId: String
  ) {
    allCommissionReportsLogs(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      status: $status
      matchType: $matchType
      commissionReport: $commissionReport
      client: $client
      memberId: $memberId
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          client
          memberId
          status
          matchType
          monthPaid
          yearPaid
          rate
          applicants
          comments
          commissionReport {
            id
            name
            effectiveMonth
            effectiveYear
          }
          stateEU {
            id
            name
            code
          }
          policy {
            id
            policyName
            memberId
          }
        }
      }
    }
  }
`

export const GET_COMMISSION_REPORTS_LOG_BY_ID_API = gql`
  query commissionReportLogById($id: String) {
    commissionReportLogById(id: $id) {
      id
      status
      rate
      applicants
      monthPaid
      yearPaid
      comments
      memberId
      client
      commissionReport {
        id
        name
        effectiveMonth
        effectiveYear
        totalApproved
        totalPending
        totalNotAssigned
      }
      stateEU {
        id
        name
      }
      policy {
        id
        policyName
        memberId
      }
    }
  }
`

export const GET_POLICY_COMMISSION_REPORTS_LOGS = gql`
  query policyCommissionReportsLogs($policyId: ID!) {
    commissionReportsLogFiltered(policyId: $policyId) {
      id
      client
      memberId
      status
      matchType
      monthPaid
      yearPaid
      rate
      applicants
      comments
      commissionReport {
        id
        name
        effectiveMonth
        effectiveYear
      }
      stateEU {
        id
        name
        code
      }
      policy {
        id
        policyName
        memberId
      }
    }
  }
`

